// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"110":"19ba8193","240":"1235528b","308":"33a89310","430":"c0891490","737":"5369b46b"}[chunkId] + ".chunk.js";
};